<template>
  <div class="nav_tab">
    <div class="nav_tab_top">
      <div
        class="tab_item"
        :class="{'tab_item_active' : tabIndex == index}"
        v-for="(item, index) in tabList"
        :key="index"
        @click="selectTabAction(index)"
      ><span>{{item}}</span></div>
    </div>

    <div class="nav_tab_bottom">
      <div
        class="select_item"
        v-for="(item, index) in selectList"
        :key="index"
        @click="selectAction(index)"
      >
        <p :class="{selectActive: selectIndex == index}">{{item}}</p><div class="line" v-if="index+1 != selectList.length && !path"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-tab",
  props:['nav_tabList'],
  data() {
    return {
      tabIndex: 0,
      selectIndex: 0,
      path: false
    };
  },
  beforeMount(){
    if(this.$route.path == '/administration'){
      this.path = true
    }
    this.tabList = this.nav_tabList.tab;
    // this.selectList = this.nav_tabList.selectItems[0];
  },
  created(){
    this.tabIndex = this.storeData.navtab; // 第一层导航
    // this.selectIndex = this.storeData.itemIndex; // 第二层导航

    this.$root.center.$emit('changeSearch',this.tabIndex);
    if(this.tabIndex == 0){
      this.selectList = this.nav_tabList.selectItems[0];
    } else if(this.tabIndex == 1){
      this.selectList = this.nav_tabList.selectItems[1];
    }
    // if(this.selectIndex == 0){
    //   this.$root.center.$emit('change_min_tab',this.selectIndex);
    // } else if(this.selectIndex == 1){
    //   this.$root.center.$emit('change_min_tab',this.selectIndex);
    // }
  },
  methods: {
    selectTabAction(index) {
      if(this.tabIndex != index){
        this.selectIndex = 0;
      }
      this.tabIndex = index;
      this.storeData.navtab = this.tabIndex;
      this.$root.center.$emit('changeSearch',index);
      if(index == 0){
        this.selectList = this.nav_tabList.selectItems[0];
      } else if(index == 1){
        this.selectList = this.nav_tabList.selectItems[1];
      }
    },
    selectAction(index){
      this.selectIndex = index;
      this.$root.center.$emit('change_min_tab',index);
    }
  }
};
</script>

<style>
/* .nav_tab {
  background: #ffffff;
  border: 0 solid #e1e6ea;
  width: 100%;
  height: 96px;
}
.nav_tab_top {
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
}
.tab_item {
  flex: 1;
  text-align: center;
  font-family: PingFangSC-Medium;
  font-size: 15px;
  color: #a0a0a0;
  letter-spacing: 0;
  text-align: center;
  padding-top: 10px;
  position: relative;
}
.tab_item_active {
  color: #5576ab;
  font-weight: 600;
}
.tab_item_active::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  display: block;
  width: 60px;
  height: 3px;
  border-radius: 3px;
  margin: auto;
  margin-top: 10px;
  background-color: #5576ab;
}
.nav_tab_bottom {
  width: 100%;
  height: 57px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.select_item {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.select_item p {
  background:#f2f2f2;
  border-radius: 100px;
  width:120px;
  font-size: 14px;
  color:#a0a0a0;
  text-align: center;
  line-height: 32px;
}
.line{
  background:#e1e6ea;
  width:1px;
  height:32px;
  position: absolute;
  right: 0;
}
.selectActive{
  color: #fff !important;
  font-weight: 600;
  line-height: 32px;
  background:#5576ab!important;
} */
</style>



// WEBPACK FOOTER //
// src/components/nav_tab/nav_tab.vue